import React from 'react';

const BidInquiryModal = ({
  bid,
  message,
  sending,
  onMessageChange,
  onSend,
  onClose
}) => {
  if (!bid) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl">
        <div className="p-4 border-b bg-gradient-to-r from-blue-500 to-blue-600 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div className="text-white">
              <h3 className="font-bold text-lg">Ask {bid.provider_name}</h3>
              <p className="text-sm text-blue-100">About: {bid.job_title}</p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white/20 p-2 rounded-lg transition"
              data-testid="close-bid-inquiry"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        
        <div className="p-6">
          {/* Bid Info Summary */}
          <div className="bg-gray-50 rounded-lg p-3 mb-4 border">
            <p className="text-sm text-gray-600">
              <span className="font-semibold">Bid Amount:</span> ₱{bid.bid_amount?.toLocaleString()}
            </p>
            <p className="text-sm text-gray-500 mt-1 line-clamp-2">
              "{bid.message}"
            </p>
          </div>
          
          <p className="text-sm text-gray-500 mb-3">
            Ask a question about this bid before making your decision.
          </p>
          
          <textarea
            value={message}
            onChange={(e) => onMessageChange(e.target.value)}
            placeholder="Hi! I have a question about your bid..."
            className="w-full p-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none resize-none"
            rows={4}
            disabled={sending}
            data-testid="bid-inquiry-textarea"
          />
          
          <div className="flex gap-3 mt-4">
            <button
              onClick={onClose}
              className="flex-1 border border-gray-300 text-gray-700 py-3 rounded-lg hover:bg-gray-50 font-semibold transition"
              disabled={sending}
            >
              Cancel
            </button>
            <button
              onClick={onSend}
              disabled={sending || !message.trim()}
              className="flex-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white py-3 rounded-lg hover:shadow-lg font-semibold disabled:opacity-50 transition flex items-center justify-center gap-2"
              data-testid="send-bid-inquiry-btn"
            >
              {sending ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Sending...
                </>
              ) : (
                <>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                  </svg>
                  Send Question
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BidInquiryModal;
